export default __webpack_public_path__ + "static/media/iam_background_s2.bf4bf543.jpg";